import { Label, Tooltip, UIHeading4, UIText2 } from '@cian/ui-kit';

import { type FC } from 'react';

import { TooltipContent } from '../../components/TooltipContent';

export const GoodPriceLabelContainer: FC = () => {
  return (
    <Tooltip
      arrow={false}
      placement="bottom"
      theme="white"
      title={
        <TooltipContent>
          <UIHeading4>Почему цена хорошая</UIHeading4>
          <UIText2>
            Цена соответствует рыночной: при расчёте мы учитываем стоимость похожих объектов в&nbsp;этом же регионе
          </UIText2>
        </TooltipContent>
      }
    >
      <Label background="surface-main-default" color="accent-main-primary" data-testid="publisher-labels.good-price">
        Хорошая цена
      </Label>
    </Tooltip>
  );
};
